import { useStaticQuery, graphql } from "gatsby";

export const GetServicesData = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpService {
        nodes {
          title
          slug
          description
          altText
          serviceImage {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          technologiesData {
            nodes {
              title
              slug
              icon
            }
          }
          subTitle
        }
      }
    }
  `);
  return data.allWpService.nodes;
};
